const normalizeBillableSeconds = (value) => {
  const seconds = Number(value);
  return Number.isFinite(seconds) && seconds > 0 ? Math.round(seconds) : 0;
};

export const MINIMAX_H3_IMAGE_PRICING = Object.freeze({
  'minimax-h3-special': { freeImages: 5, creditsPerImage: 3 },
  'minimax-h3': { freeImages: 5, creditsPerImage: 8 },
  'minimax-h3-vip': { freeImages: 5, creditsPerImage: 12 },
  'minimax-h3-max': { freeImages: 2, creditsPerImage: 30 },
});

export const getMiniMaxH3InputImageCost = ({ modelKey, inputImageCount = 0 } = {}) => {
  const pricing = MINIMAX_H3_IMAGE_PRICING[modelKey];
  const count = Number(inputImageCount);
  if (!pricing || !Number.isFinite(count) || count <= pricing.freeImages) return 0;
  return Math.max(0, Math.floor(count) - pricing.freeImages) * pricing.creditsPerImage;
};

export const getMiniMaxH3BillableDuration = ({
  outputDuration,
  inputVideoDuration,
  fallbackOutputDuration = 5,
} = {}) => {
  const outputSeconds = normalizeBillableSeconds(outputDuration)
    || normalizeBillableSeconds(fallbackOutputDuration);
  const inputSeconds = normalizeBillableSeconds(inputVideoDuration);

  return outputSeconds + inputSeconds;
};

export const getMiniMaxH3CreditCost = ({
  modelKey,
  inputImageCount,
  outputDuration,
  inputVideoDuration,
  perSecondCost,
  fallbackOutputDuration = 5,
} = {}) => {
  const rate = Number(perSecondCost);
  if (!Number.isFinite(rate) || rate <= 0) return 0;

  return getMiniMaxH3BillableDuration({
    outputDuration,
    inputVideoDuration,
    fallbackOutputDuration,
  }) * rate + getMiniMaxH3InputImageCost({ modelKey, inputImageCount });
};
